export const JuchuNyuryokuDetailCtrl1 = (shoriSentaku: string, hinmokuKbn: boolean) => {
  let res: boolean = true;
  if (shoriSentaku === '1' || shoriSentaku === '2') {
    res = false;
  }
  if (hinmokuKbn) {
    res = true;
  }
  return res;
};

export const JuchuNyuryokuDetailCtrl2 = (
  shoriSentaku: string,
  geniraiKbn: boolean,
  iroKbn: boolean
) => {
  let res: boolean = true;
  if (shoriSentaku === '1' || shoriSentaku === '2') {
    res = false;
  }
  if (geniraiKbn) {
    res = true;
  }
  if (iroKbn) {
    res = true;
  }
  return res;
};

export const JuchuNyuryokuDetailCtrl3 = (shoriSentaku: string, geniraiKbn: boolean) => {
  let res: boolean = true;
  if (shoriSentaku === '1' || shoriSentaku === '2') {
    res = false;
  }
  if (geniraiKbn) {
    res = true;
  }
  return res;
};

export const JuchuNyuryokuDetailCtrl4 = (shoriSentaku: string, dispNo: boolean) => {
  let res: boolean = true;
  if (shoriSentaku === '1' || shoriSentaku === '2') {
    res = false;
  }
  if (dispNo) {
    res = false;
  } else {
    res = true;
  }
  return res;
};

export const JuchuNyuryokuDetailCtrl5 = (setKbn: string, barashiKbn: string) => {
  let res: boolean = true;
  if (setKbn === '1') {
    res = false;
  }
  if (setKbn === '1' && barashiKbn === '1') {
    res = true;
  }
  return res;
};
